export function buildHeaders(params: Record<string, any | undefined>): string {
  return Object.entries(params)
    .map(([key, value]) => `${key}=${value}`)
    .join(',')
}

export function buildSearchParams(params: {
  [param: string]: string | string[] | undefined
}): string {
  const searchParams = new URLSearchParams()

  for (const param in params) {
    const paramValue = params[param]
    if (paramValue !== undefined && paramValue.length) {
      Array.isArray(paramValue)
        ? searchParams.set(param, paramValue.join(','))
        : searchParams.set(param, paramValue)
    }
  }

  return searchParams.toString()
}
